import React, { useContext, useEffect } from "react";
// import Chip from '@material-ui/core/Chip';
import { StoreContext } from "../../../../../Store/Provider";
import "./shipmentCard.css";
// import moment from 'moment'
import BCN from "../../../../SVG/BCN";
import FCL from "../../../../SVG/FCL";
import LCL from "../../../../SVG/LCL";
import Line from "../../../../SVG/Line";
import Locate from "../../../../SVG/Locate";
import LSE from "../../../../SVG/LSE";
import Sea from "../../../../SVG/Sea";
import Plane from "../../../../SVG/Plane";
import PlaceDot from "../../../../SVG/PlaceDot";
import RoadSVG from "../../../../SVG/RoadSVG.js";
import CourierSVG from "../../../../SVG/CourierSVG";
import RailSVG from "../../../../SVG/RailSVG";

function ShipmentCard(props) {
  const context = useContext(StoreContext);
  const { loadedData, index } = props;

  const locateMap = async (e) => {
    e.stopPropagation();
    await context.setShipmentNo(loadedData?.ShipmentId);
    props.handleDrawer(loadedData);
    context.setSidebarContent("track");
    context.setSelectedIndex(index);
  };

  useEffect(() => {
    context.setShipmentStatus(loadedData?.ShipmentStatus);
  }, [context.shipmentNo]);

  return (
    <div
      className={
        context.selectedIndex === index
          ? `shipmentCardOuter tranformAnimationmin active ${
              index === 0 ? "ToureigthStep" : ""
            }`
          : "shipmentCardOuter tranformAnimationmin"
      }
      onClick={() => {
        context.setShipmentNo(loadedData?.ShipmentId);
        props.handleDrawer(loadedData);
        context.setSelectedIndex(index);
      }}
    >
      <div className={`shpTypeDiv`}>
        {loadedData?.TransportMode === "AIR" ||
        loadedData?.ContainerMode === "LCL" ? null : (
          <div className="shpTypeCountDiv">
            {loadedData?.ContainerCount ? loadedData?.ContainerCount : "0"}
          </div>
        )}
        <div className="shpType">
          {loadedData?.ContainerMode === "LCL" ? (
            <LCL colorCode={"rgba(var(--text-heading-dark))"} />
          ) : loadedData?.ContainerMode === "FCL" ? (
            <FCL colorCode={"rgba(var(--text-heading-dark))"} />
          ) : loadedData?.ContainerMode === "BCN" ? (
            <BCN colorCode={"rgba(var(--text-heading-dark))"} />
          ) : (
            <LSE colorCode={"rgba(var(--text-heading-dark))"} />
          )}
          <p>{loadedData?.ContainerMode}</p>
        </div>
      </div>
      <div className="shpDetailsDiv">
        <div className="shpDetailsDivIdImg">
          <div className="shpDetailsDivId">
            <span>Shipment ID</span>
            <p>{loadedData?.ShipmentId}</p>
          </div>
        </div>
        <div className="dataChipForm"></div>
      </div>
      <div className="shpDetailsRouteDiv">
        <p className="etdEtap">
          <span>
            {loadedData?.ShipmentOriginETD
              ? loadedData?.ShipmentOriginETD.includes("1900") ||
                loadedData?.ShipmentOriginETD.includes("0001")
                ? "N/A"
                : loadedData?.ShipmentOriginETD.split(" ")[0]
              : ""}
          </span>
          <span>
            {loadedData?.ShipmentDestinationETA
              ? loadedData?.ShipmentDestinationETA.includes("1900") ||
                loadedData?.ShipmentDestinationETA.includes("0001")
                ? "N/A"
                : loadedData?.ShipmentDestinationETA.split(" ")[0]
              : ""}
          </span>
        </p>
        <div className="shptimelinebody">
          <span title={loadedData?.OriginPort}>{loadedData.OriginPort}</span>
          <div className="shptimelinecontainer">
            <span>
              {loadedData.TransportMode === "SEA" ? (
                <Sea
                  colorCode={"rgba(var(--text-heading-dark))"}
                  seaClass={"shptimelinemode"}
                />
              ) : loadedData.TransportMode === "ROA" ? (
                <RoadSVG
                  colorCode={"rgba(var(--text-heading-dark))"}
                  planeClass={"shptimelinemode"}
                />
              ) : loadedData.TransportMode === "COU" ? (
                <CourierSVG
                  colorCode={"rgba(var(--text-heading-dark))"}
                  planeClass={"shptimelinemode"}
                />
              ) : loadedData.TransportMode === "RAI" ? (
                <RailSVG
                  colorCode={"rgba(var(--text-heading-dark))"}
                  planeClass={"shptimelinemode"}
                />
              ) : loadedData.TransportMode === "AIR" ? (
                <Plane
                  colorCode={"rgba(var(--text-heading-dark))"}
                  planeClass={"shptimelinemode"}
                />
              ) : null}
            </span>
            <span>
              <PlaceDot colorCode={"rgba(var(--text-heading-dark))"} />
            </span>
            <Line
              colorCode={"rgba(var(--text-heading-dark))"}
              classDotted={"dottedline"}
            />
          </div>
          <span title={loadedData?.DestinationPort}>
            {loadedData?.DestinationPort}
          </span>
        </div>
      </div>
      <div className="locateDiv tranformAnimation">
        <Locate
          class={""}
          colorCode={"rgba(var(--text-heading-dark))"}
          onClickLocate={locateMap}
        />
      </div>
    </div>
  );
}

export default ShipmentCard;
